import { useState } from 'react'
import { UpdatableReactElement } from 'shared/utils/react.utils'

type ModalType = {
    element: UpdatableReactElement
    id: string
}

export type ModalContainerAccessorType = {
    modals: ModalType[]
    addModal: (modal: ModalType) => void
    removeModal: (modal: ModalType) => void
}

export const useModalContainer = (): ModalContainerAccessorType => {
    const [modals, setModals] = useState<ModalType[]>([])

    const addModal = (modal: ModalType) => {
        setModals(prev => [...prev, modal])
    }

    const removeModal = (modal: ModalType) => {
        setModals(prev => prev.filter(m => m !== modal))
    }

    return {
        modals,
        addModal,
        removeModal,
    }
}
